import './FullScreen.css';
import React, { useState } from "react";
import AddTask from '../../tasks/AddTask.js'
import ProjectBlock from '../../goals/pillars/ProjectBlock.js';

function StandupFullScreen(props) {
    const [activeStep, setActiveStep] = useState(1)
    const [activeInput, setActiveInput] = useState(0)
    const [progressInput, setProgressInput] = useState("none")
    const [targetInput, setTargetInput] = useState("none")
    const [blockersInput, setBlockersInput] = useState("none")
    const [email, setEmail] = useState(false)
    const [webFunct, setWebFunct] = useState(false)
    const [mobileFunct, setMobileFunct] = useState(false)
    const [showAddTasks, setShowAddTasks] = useState(null)

    function clearProjectTaskAdd() {
        setShowAddTasks(null)
    }

    const handleProgressChange = (event) => {
        setProgressInput(event.target.value);
      };
      const handleTargetChange = (event) => {
        setTargetInput(event.target.value);
      };
      const handleBlockersChange = (event) => {
        setBlockersInput(event.target.value);
      };

    return (
        <div className="fullScreen standupFullScreen">
            {showAddTasks!==null &&
                <AddTask project={showAddTasks} tasks={props.tasks} setTasks={props.setTasks} userProfile={props.userProfile} setShowAddTask={clearProjectTaskAdd}/>
            }
            <p className="standupHeader"> STANDUP </p>
            <p onClick={() => props.setShowFullScreen(false)} className="standupCloseButton"> close </p>
            <div className="activeProjectStandupBlock">
                <p className="standupProjectHeader"> project: {props.userProfile.projects[activeStep - 1].title} </p>
                <p onClick={()=> setShowAddTasks(activeStep-1)} className="standupAddTaskButton"> add a task for this project </p>
                {activeInput === 0 && 
                <div>
                    <p className="standupProjectSubHeader"> progress made to goals yesterday: </p>
                    <textarea
                    className="progressInput"
                    type="text"
                    id="progressInput"
                    value={progressInput}
                    onChange={handleProgressChange}
                    name="progressInput"
                    spellCheck="false"
                    />
                </div>}
                {activeInput === 1 && 
                <div>
                    <p className="standupProjectSubHeader"> progress targets for today: </p>
                    <textarea
                    className="progressInput"
                    type="text"
                    id="targetInput"
                    value={targetInput}
                    onChange={handleTargetChange}
                    name="targetInput"
                    spellCheck="false"
                    />
                </div>}
                {activeInput === 2 && 
                <div>
                    <p className="standupProjectSubHeader"> current blockers: </p>
                    <textarea
                    className="progressInput"
                    type="text"
                    id="blockersInput"
                    value={blockersInput}
                    onChange={handleBlockersChange}
                    name="blockersInput"
                    spellCheck="false"
                    />
                </div>}
                {activeInput === 3 && 
                <div className="">
                    <div className="standupCheckboxRow">
                    <div className={email ? "standupCheckBox standupCheckBoxChecked" : "standupCheckBox"} onClick={() => setEmail(!email)}> </div>
                        <p className="standupProjectSubHeader"> check email </p>
                    </div>
                    <div className="standupCheckboxRow">
                    <div className={webFunct ? "standupCheckBox standupCheckBoxChecked" : "standupCheckBox"} onClick={() => setWebFunct(!webFunct)}> </div>
                        <p className="standupProjectSubHeader"> check web functionality </p>
                    </div>
                    <div className="standupCheckboxRow">
                        <div className={mobileFunct ? "standupCheckBox standupCheckBoxChecked" : "standupCheckBox"} onClick={() => setMobileFunct(!mobileFunct)}> </div>
                        <p className="standupProjectSubHeader"> check mobile functionality </p>
                    </div>
                </div>
                }
                {activeInput === 4 && 
                <div>
                    <p className="standupProjectSubHeader"> review upcoming events and deadlines: </p>
                </div>}
                <div className="circleStandupRow">
                    <div onClick={() => setActiveInput(0)} className="standupBlockCircle">
                        {progressInput !== "none"  && activeInput !== 0 &&
                            <div className="standupBlockInnerCircle"></div>
                        }
                        {activeInput === 0  &&
                            <div className="standupBlockInnerCircle standupPulsing"></div>
                        }
                    </div>
                    <div onClick={() => setActiveInput(1)} className="standupBlockCircle">
                        {targetInput !== "none"  && activeInput !== 1 &&
                            <div className="standupBlockInnerCircle"></div>
                        }
                        {activeInput===1  &&
                            <div className="standupBlockInnerCircle standupPulsing"></div>
                        }
                    </div>
                    <div onClick={() => setActiveInput(2)} className="standupBlockCircle">
                        {blockersInput !== "none"  && activeInput !== 2 &&
                            <div className="standupBlockInnerCircle"></div>
                        }
                        {activeInput===2  &&
                            <div className="standupBlockInnerCircle standupPulsing"></div>
                        }
                    </div>
                    <div onClick={() => setActiveInput(3)} className="standupBlockCircle">
                        {email && webFunct && mobileFunct && activeInput !== 3 &&
                            <div className="standupBlockInnerCircle "></div>
                        }
                        {activeInput===3  &&
                            <div className="standupBlockInnerCircle standupPulsing"></div>
                        }
                    </div>
                    <div onClick={() => setActiveInput(4)} className="standupBlockCircle">
                        {false &&
                            <div className="standupBlockInnerCircle"></div>
                        }
                        {activeInput===4  &&
                            <div className="standupBlockInnerCircle standupPulsing"></div>
                        }
                    </div>
                </div>

                <p className="standupProjectSubHeader"> all projects: </p>
                <div className="standupProjects">
                {props.userProfile.projects.map((project, index) => (
                    <div className="standupProject" key={index} onClick={() => setActiveStep(index + 1)}>
                        <ProjectBlock unstyled={true} title={project.shortName} color={activeStep>index ? project.backgroundColor: 0} />
                    </div>
                ))}
            </div>
            <p onClick={() => props.setFinished(true)} className="finishedButton"> all finished</p>
            </div>
        </div>
    )
}

export default StandupFullScreen;